import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { InitialAvatarImage } from '@warrenbrasil/nebraska-web';
import { InstrumentAvatarFallback } from '@/modules/trade/components/InstrumentAvatarFallback';

import { getInstrumentSymbolPreffix } from '@/modules/trade/helpers/instruments';
import { InstrumentType } from '@/modules/trade/types/bff';

interface Props {
  size: string;
  symbol: string;
  instrumentType?: InstrumentType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InstrumentAvatar',
  props: {
    size: null,
    symbol: null,
    instrumentType: null
  },
  setup(__props: any) {

const props = __props as {
  size: string;
  symbol: string;
  instrumentType?: InstrumentType;
}



const symbolPreffix = computed(() => {
  return getInstrumentSymbolPreffix(props.symbol);
});

return { __sfc: true,props, symbolPreffix, InitialAvatarImage, InstrumentAvatarFallback }
}

})